import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "../../axios";
import { StatisticDataType } from "@/common/types";

const periodType = ["day", "week", "month", "year"] as const;
type PeriodType = (typeof periodType)[number];

const getMeQuoteStatistic = async (periodType: PeriodType) => {
  const params = new URLSearchParams({ periodType });
  return await axiosInstance
    .get("quotes/statistic/me", { params })
    .then((res) => res.data)
    .catch((e) => {
      throw e;
    });
};

const useGetMeQuoteStatistic = (periodType: PeriodType) => {
  return useQuery<StatisticDataType>({
    queryKey: ["quoteStatistic", "me", periodType],
    queryFn: () => getMeQuoteStatistic(periodType),
  });
};

export default useGetMeQuoteStatistic;
